module.exports = __webpack_public_path__ + "img/ring_g_i_0_0@3x.9416d51f.png";